import { render, staticRenderFns } from "./ConversationDateField.vue?vue&type=template&id=9965ceea&scoped=true&"
import script from "./ConversationDateField.vue?vue&type=script&lang=js&"
export * from "./ConversationDateField.vue?vue&type=script&lang=js&"
import style0 from "./ConversationDateField.vue?vue&type=style&index=0&id=9965ceea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965ceea",
  null
  
)

export default component.exports